import {Component, Input} from '@angular/core';
import {RankingListItem} from "../../../../interfaces/ranking-list-item";

@Component({
  selector: 'brt-ranking-list-item',
  templateUrl: './ranking-list-item.component.html',
  styleUrls: ['./ranking-list-item.component.scss']
})
export class RankingListItemComponent {
  @Input('data') set setItem(item: RankingListItem) {
    const playedTime = item.playedTime;

    if(playedTime === 0) {
      this.playedTimeString = "Noch nicht gespielt";
    } else {
      const hours = Math.floor(playedTime / 60);
      const minutes = playedTime % 60;

      this.playedTimeString = `${hours > 0 ? hours + ' Std.' : ''} ${minutes} Min.`.trim();
    }
    this.item = item;
  }
  item!: RankingListItem;

  playedTimeString = "";

}
